module.exports = __webpack_public_path__ + "img/01-1可乐.8e345226.png";